import { ChainType } from "@0xsquid/squid-types";
import { UseMutationResult } from "@tanstack/react-query";
import React, { createContext, ReactNode, useContext } from "react";
import { useCanton } from "../../hooks/canton/useCanton";
import { CantonConnector } from "../types/canton";
import { CantonWallet, ConnectWalletResult } from "../types/wallet";

export interface ICantonContextData {
  connectCanton: UseMutationResult<
    ConnectWalletResult<ChainType.CANTON>,
    unknown,
    {
      wallet: CantonWallet;
    },
    unknown
  >;
  disconnectCanton: () => Promise<void>;
  autoConnectCanton: () => Promise<void>;
  signer: CantonConnector | undefined;
  wallets: CantonWallet[];
}

export const CantonContext = createContext<ICantonContextData | undefined>(
  undefined
);

export const CantonProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const cantonHook = useCanton();

  return (
    <CantonContext.Provider value={cantonHook}>
      {children}
    </CantonContext.Provider>
  );
};

export const useCantonContext = (): ICantonContextData => {
  const context = useContext(CantonContext);
  if (!context) {
    throw new Error("useCantonContext must be used within a CantonProvider");
  }
  return context;
};
